import React from 'react';
import Card from 'react-bootstrap/Card';
import ShowMoreText from 'react-show-more-text';
import projImg21 from '../../assets/img/2-1.png';
import projectimage9 from '../../assets/img/p9.png';

const PreviousCard9 = () => {
    return (
        <Card className="CARD2" bg="dark">
              {/* <Card.Title><h2>Predicting student performance in "Technical Chemistry"</h2></Card.Title> */}

              <Card.Img variant="top" src={projectimage9} />

              <Card.Body>
                <Card.Text>
                  {" "}
                  <img className="img2" src={projImg21} />{" "}
                  <p className="text7">Mihály Szabó </p>
                  <br />
                  <p className="text8">
                    Rector's delegate <br />
                    Rector's Office, Directorate of Education, BME
                  </p>
                </Card.Text>
                <ShowMoreText lines={1}>
                  <div>
                    In previous work by HSDSLab, we studied the prediction of
                    academic success for first-year students entering the
                    Budapest University of Technology and Economics (BME),
                    analyzing the relationships between pre-enrollment
                    achievement measures used as the basis for admission and
                    subsequent university performance. An important question we
                    addressed was which elements of the admission score have the
                    strongest explanatory power for future academic performance.
                    Using modern statistical and machine learning tools (random
                    forests, neural networks, and boosting methods), we
                    conducted this research on historical data, applying
                    predictive analytical methods to determine how well the data
                    available at the time of admission can indicate whether a
                    given student will complete their studies successfully and
                    with what level of performance. As a continuation of this
                    work, in the framework of the proposed research, the student
                    should investigate how successful completion of the
                    first-semester course entitled "Technical Chemistry" at the
                    Faculty of Transportation Engineering and Vehicle
                    Engineering at BME can be predicted based on data available
                    at the time of admission and which competencies are most
                    crucial. Can those who are likely to perform poorly be
                    identified so that support measures, such as remedial
                    classes, consultation sessions, and other forms of
                    assistance, can be provided to help them catch up during the
                    semester?
                    <br />
                    <br />
                    Recommended literature:{" "}
                    <ul>
                      <li>
                        Ozsogomonyan, A., & Loftus, D. (1979). Predictors of
                        general chemistry grades.
                        <span className="text9"> Journal of Chemical Education </span>
                        , 56(3), 173.{" "}
                      </li>

                      <li>
                        Daniel House, J. (1995). Noncognitive predictors of
                        achievement in introductory college chemistry.
                        <span className="text9"> Research in Higher Education </span>,
                        36, 473-490.{" "}
                      </li>

                      <li>
                        Wagner, E. P., Sasser, H., & DiBiase, W. J. (2002).
                        Predicting students at risk in general chemistry using
                        pre-semester assessments and demographic information.
                        <span className="text9"> Journal of Chemical Education </span>
                        , 79(6), 749.{" "}
                      </li>

                      <li>
                        Lopez, E. J., Shavelson, R. J., Nandagopal, K., Szu, E.,
                        & Penn, J. (2014). Factors contributing to
                        problem-solving performance in first-semester organic
                        chemistry.{" "}
                        <span className="text9"> Journal of Chemical Education </span>
                        , 91(7), 976-981.{" "}
                      </li>

                      <li>
                        Fink, A., Frey, R. F., & Solomon, E. D. (2020).
                        Belonging in general chemistry predicts first-year
                        undergraduates’ performance and attrition.
                        <span className="text9">
                          {" "}
                          Chemistry Education Research and Practice{" "}
                        </span>
                        , 21(4), 1042-1062.{" "}
                      </li>

                      <li>
                        Kiss, B., Nagy, M., Molontay, R., & Csabay, B. (2019,
                        November). Predicting dropout using high school and
                        first-semester academic achievement measures. In 2019
                        <span className="text9">
                          {" "}
                          17th international conference on emerging eLearning
                          technologies and applications (ICETA){" "}
                        </span>
                        (pp. 383-389). IEEE.{" "}
                      </li>

                      <li>
                        Baranyi, M., Gál, K., Molontay, R., & Szabó, M. (2019,
                        November). Modeling students’ academic performance using
                        Bayesian networks. In 2019{" "}
                        <span className="text9">
                          {" "}
                          17th international conference on emerging eLearning
                          technologies and applications (ICETA){" "}
                        </span>
                        (pp. 42-49). IEEE.{" "}
                      </li>

                      <li>
                        Baranyi, M., Nagy, M., & Molontay, R. (2020, October).
                        Interpretable deep learning for university dropout
                        prediction. In{" "}
                        <span className="text9">
                          {" "}
                          Proceedings of the 21st annual conference on
                          information technology education{" "}
                        </span>
                        (pp. 13-19).{" "}
                      </li>
                    </ul>
                  </div>
                </ShowMoreText>
              </Card.Body>
            </Card>
    );
}

export default PreviousCard9;
